import { UPLOAD_BASE } from '../api/axios';

export const getImageUrl = (filename) => {
  if (!filename) return '';
  const base = UPLOAD_BASE.replace(/\/$/, '');
  return `${base}/images/${encodeURIComponent(filename)}`;
};